<template>
    <div class="container-fluid company-listing">
        <div class="row">
            <div class="position-relative w-100">
                <companies-tab
                    :origin="'dashboard'"
                    v-on:viewCompanyDetails="viewCompanyDetails"
                    v-if="!showDetails"
                ></companies-tab>
                <div v-else>
                    <dashboard-company-details
                        :company="company"
                        :remote_measures="remote_measures"
                        :is_following="is_following"
                        origin="dashboard"
                        v-on:backToHome="backToHome"
                    ></dashboard-company-details>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DropdownOptionsConfig from "../../Company/DropdownOptionsConfig";
import CompanyState from "../../Company/NewCompanyState";

export default {
    data() {
        return {
            showDetails: false,
            company: CompanyState.company,
            remote_measures: CompanyState.remote_measures,
            is_following: true
        };
    },

    methods: {
        async getCompanyDetails(companyId) {
            const res = await axios.get(`/companies/${companyId}`);
            const data = res.data.data.company;
            this.company.id = data.id;
            this.company.name = data.name;
            this.company.employee_count = data.employee_count;
            this.company.country = data.country;
            this.company.city = data.city;
            this.company.other_remarks = data.other_remarks;
            this.company.logo_src = data.logo_src;
            this.company.offices = data.offices;

            Object.keys(DropdownOptionsConfig.wfhOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.wfhOptions[key] ===
                    data.allow_work_from_home
                ) {
                    this.company.work_from_home = key;
                }
            });

            Object.keys(DropdownOptionsConfig.travelOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.travelOptions[key] ===
                    data.allow_travel
                ) {
                    this.company.travel = key;
                }
            });

            Object.keys(DropdownOptionsConfig.visitorOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.visitorOptions[key] ===
                    data.allow_visitors
                ) {
                    this.company.visitors = key;
                }
            });

            Object.keys(DropdownOptionsConfig.eventsOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.eventsOptions[key] ===
                    data.allow_events
                ) {
                    this.company.events = key;
                }
            });

            const remoteMeasure = res.data.data.remote_measures;
            this.remote_measures.video_conference =
                remoteMeasure.uses_video_conference_tools === 1;
            this.remote_measures.project_management =
                remoteMeasure.uses_project_management_tools === 1;
            this.remote_measures.clear_sop = remoteMeasure.has_clear_sops === 1;
            this.remote_measures.set_communications_protocol =
                remoteMeasure.set_communications_protocol === 1;
            this.remote_measures.help_remote_ready =
                remoteMeasure.needs_help_remote_ready === 1;
            this.remote_measures.schedule_regular_scrums =
                remoteMeasure.schedule_regular_scrums === 1;
            this.remote_measures.uses_git = remoteMeasure.uses_git === 1;
            this.remote_measures.has_tech_team =
                remoteMeasure.has_tech_team === 1;
        },

        async viewCompanyDetails(companyId) {
          const res = await axios.get(`/company/${companyId}/following`);
          this.is_following = res.data.data;
          await this.getCompanyDetails(companyId);
          this.showDetails = true;
        },

        backToHome() {
            this.showDetails = false;
        }
    }
};
</script>

<style scoped lang="scss">
.company-listing {
}
</style>
